import React from "react";
import { ExternalLink, Zap } from "lucide-react";

const sites = [
  {
    name: "AcidPrompt",
    url: "https://acidprompt.com",
    description:
      "AcidPrompt helps you create, manage, and optimize your AI prompts.",
    image: "/images/acidprompt.png",
    category: "Artificial Intelligence",
    features: [
      "Create, manage, and optimize your AI prompts",
      "Save time and increase productivity",
      "Perfect for ChatGPT, Claude, and all AI platforms",
      "800+ prompts, Free and PRO plans",
    ],
  },
  {
    name: "Life's Ruler",
    url: "https://lifesruler.com",
    description:
      "Let Life's Ruler show you the importance of education. Try our lifestyle calculator to see if you can afford your desired lifestyle.",
    image: "/images/lifesruler.png",
    category: "Education",
    features: [
      "Life's Ruler Tool",
      "Lifestyle Calculator",
      "Credit Card Interest Calculator",
      "Mortgage Calculator",
    ],
  },
  {
    name: "Life's Check",
    url: "https://lifescheck.com",
    description:
      "Much like Life's Ruler, Life's Check is a tool that helps you check your finances, but with a twist. It's a tool that helps you check your finances, with AI reports.",
    image: "/images/lifescheck.png",
    category: "Fincances",
    features: [
      "See your financial health",
      "Read our extensive FAQs",
      "Are you ready for retirement?",
      "Generate customized AI reports",
    ],
  },
  {
    name: "GPT Book Hub",
    url: "https://gptbookhub.com",
    description:
      "Check out our fun GPT generated books that can be downloaded or printed for you by Amazon.",
    image: "/images/gptbookhub.png",
    category: "Education",
    features: [
      "Shroud of Darkness",
      "Our Top selling: The Ultimate ChatGPT Prompt Guide",
      "250 Backhanded Compliments",
      "Wisdom Rebooted: If they were alive today",
    ],
  },
  {
    name: "Side Hustle Tool",
    url: "https://sidehustletool.com",
    description:
      "We have curated a list of incredible tools to help you with your side hustle.",
    image: "/images/sidehustletool.png",
    category: "Business",
    features: [
      "20 Sidehustle ideas",
      "250 Awesome tools in 1 place",
      "25 How to video links",
      "Easy access",
    ],
  },
  
  {
    name: "Stupid AI",
    url: "https://stupidai.site",
    description:
      "An'AI' site to make fun of AI.",
    image: "/images/stupidai.png",
    category: "Artificial Intelligence",
    features: [
      "Create, manage, and optimize your AI prompts",
      "Save time and increase productivity",
      "Perfect for ChatGPT, Claude, and all AI platforms",
      "800+ prompts, Free and PRO plans",
    ],
  },
  {
    name: "123FYI (Coming Soon)",
    url: "https://123fyi.com",
    description:
      "Our latest project, 123FYI.com, is a tool that helps you find the best products and services for your needs.",
    image: "/images/123FYI.png",
    category: "Education",
    features: [
      "Join our waitlist",
      "All the FAQ's in one place",
      "What to know before you buy",
      "Top 10 lists",
    ],
  },
];

const PortfolioPage = () => {
  return (
    <div className="max-w-7xl mx-auto py-12 px-4">
      <div className="space-y-8">
        {/* Header Section */}
        <div className="text-center space-y-4 mb-12">
          <h1 className="text-4xl font-bold">DGF Digital Solutions</h1>
          <p className="text-lg text-muted-foreground">for Everyone</p>
          <p className="mt-6 max-w-2xl mx-auto text-xl text-muted-foreground">
            Explore our suite of sites that have something for everyone
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid gap-12">
          {sites.map((site) => (
            <div
              key={site.name}
              className="bg-card border rounded-xl shadow-sm overflow-hidden"
            >
              <div className="grid md:grid-cols-2 gap-8 p-8">
                {/* Left Column: Content */}
                <div className="flex flex-col justify-between space-y-6">
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-2xl font-bold">{site.name}</h2>
                      <a
                        href={site.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-primary hover:text-primary/80"
                      >
                        <span className="mr-2">Visit Site</span>
                        <ExternalLink className="w-5 h-5" />
                      </a>
                    </div>
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-primary/10 text-primary">
                      {site.category}
                    </span>
                    <p className="mt-4 text-muted-foreground">
                      {site.description}
                    </p>
                  </div>

                  {/* Features List */}
                  <div className="grid grid-cols-2 gap-4">
                    {site.features.map((feature, index) => (
                      <div
                        key={index}
                        className="flex items-center text-muted-foreground"
                      >
                        <Zap className="w-4 h-4 text-primary mr-2" />
                        <span className="text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right Column: Image */}
                <div className="relative">
                  <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden">
                    <img
                      src={site.image}
                      alt={`${site.name} preview`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;
